export default [
  {
    path: 'direction-sector-codes',
    name: 'direction-sector-codes',
    component: () => import('@/views/pages/direction-sector-code/Index.vue'),
    meta: {
      pageTitle: 'Science sector directions',
      breadcrumb: [
        {
          text: 'Science sector directions',
          active: true,
        },
      ],
      resource: 'DirectionSectorCode',
    },
  },
]
